export default {
  toServer: data => ({
    created_by: data.createdBy,
    text: data.text,
    updated_by: data.updatedBy,
    uid: data.uid,
    references_added: data.referencesAdded,
    references_removed: data.referencesRemoved,
    is_draft: data.isDraft,
  }),
};
